// @mui
import { Button, Container } from '@mui/material';
// sections
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router-dom';
import Iconify from 'src/components/iconify';
import { ICustomer } from '../../../@types/customer';
import { IUser } from '../../../@types/user';
import { useAuthContext } from '../../../auth/useAuthContext';
import CustomBreadcrumbs from '../../../components/custom-breadcrumbs';
// components
import { useSettingsContext } from '../../../components/settings';
import { useLocales } from '../../../locales';
import { searchCustomersRaw } from '../../../redux/slices/customer';
// routes
import { PATH_DASHBOARD, PATH_PAGE } from '../../../routes/paths';
import CustomerNewEditForm from '../../../sections/@dashboard/customer/CustomerNewEditForm';
import { PERMISSIONS, hasPermission } from '../../../utils/permissions';

// ----------------------------------------------------------------------

export default function CustomerEditPage() {
  const { translate } = useLocales();
  const { themeStretch } = useSettingsContext();

  const { id } = useParams();

  const [currentUser, setCurrentUser] = useState<ICustomer | undefined>(
    undefined
  );

  const { user } = useAuthContext();
  const navigate = useNavigate();

  if (!hasPermission(user as IUser, PERMISSIONS.customerEdit)) {
    navigate(PATH_PAGE.page403);
  }

  useEffect(() => {
    const fetchUser = async () => {
      if (!id) return;

      const users = await searchCustomersRaw({
        id: {
          _eq: id,
        },
      });

      setCurrentUser(users?.data?.[0]);
    };

    fetchUser();
  }, [id]);

  return (
    <>
      <Button
        color="inherit"
        startIcon={<Iconify width={16} icon={'eva:arrow-ios-back-fill'} />}
        sx={{
          height: 40,
          flexShrink: 0,
          borderRadius: 0,
          typography: 'overline',
          color: 'text.disabled',
          justifyContent: 'space-between',
          p: (theme) => theme.spacing(1, 1.5, 1, 2.5),
        }}
        onClick={() => navigate(-1)}
      >
        {`${translate('backward')}`}
      </Button>
      <Helmet>
        <title> {`${translate('customersEditPage.title')}`} </title>
      </Helmet>

      <Container maxWidth={themeStretch ? false : 'lg'}>
        <CustomBreadcrumbs
          heading={`${translate('customersEditPage.heading')}`}
          links={[
            {
              name: `${translate('dashboardName')}`,
              href: PATH_DASHBOARD.root,
            },
            {
              name: `${translate('customersPage.navTitle')}`,
              href: PATH_DASHBOARD.customers.list,
            },
            { name: `${currentUser?.first_name} ${currentUser?.last_name}` },
          ]}
        />

        <CustomerNewEditForm isEdit currentCustomer={currentUser} />
      </Container>
    </>
  );
}
